import { QueryClient, QueryCache, MutationCache } from '@tanstack/react-query'
import { captureException } from '@sentry/react'
import { isSessionRejectedError, forceSignOutToLogin } from '@/lib/auth-session'

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError(error) {
      // Backstop for a session that dies mid-use: any Supabase 401 /
      // session_not_found ends in a forced sign-out, never an empty CRM
      if (isSessionRejectedError(error)) void forceSignOutToLogin()
    },
  }),
  mutationCache: new MutationCache({
    onError(error, _variables, _context, mutation) {
      if (isSessionRejectedError(error)) {
        void forceSignOutToLogin()
        return
      }
      captureException(error, {
        tags: {
          mutation_key: mutation.options.mutationKey?.join('.') ?? 'unknown',
        },
      })
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})
